"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.gridConfig = void 0;
var _stylitas = require("@creditas/stylitas");
const defaultConfig = {
  gridColumns: {
    xs: 'repeat(8, 1fr)',
    md: 'repeat(12, 1fr)'
  },
  gridColumnGap: {
    xs: '8px',
    md: '24px'
  },
  gridPadding: ['0 20px', '0 20px', '0 24px', '0'],
  gridRows: {
    xs: null,
    md: null
  },
  gridAreas: {
    xs: null,
    md: null
  },
  gridRowGap: {
    xs: null,
    md: null
  }
};
const gridConfig = _ref => {
  let {
    options
  } = _ref;
  const config = {
    ...defaultConfig,
    ...options
  };
  const {
    gridAreas,
    gridColumns,
    gridRows,
    gridJustifyItems,
    gridJustifyContent,
    gridAlignItems,
    gridAlignContent,
    gridRowGap,
    gridColumnGap,
    gridPadding
  } = config;
  return (0, _stylitas.css)`
    display: grid;
    justify-items: ${gridJustifyItems};
    align-items: ${gridAlignItems};
    align-content: ${gridAlignContent};
    justify-content: ${gridJustifyContent};

    ${(0, _stylitas.mq)({
    gridTemplateAreas: (0, _stylitas.mediaValue)(gridAreas.xs, gridAreas.md),
    gridTemplateColumns: (0, _stylitas.mediaValue)(gridColumns.xs, gridColumns.md),
    gridTemplateRows: (0, _stylitas.mediaValue)(gridRows.xs, gridRows.md),
    gridRowGap: (0, _stylitas.mediaValue)(gridRowGap.xs, gridRowGap.md),
    gridColumnGap: (0, _stylitas.mediaValue)(gridColumnGap.xs, gridColumnGap.md),
    padding: gridPadding
  })}
  `;
};
exports.gridConfig = gridConfig;